module.exports = __webpack_public_path__ + "img/article_mobile.8d384771.webp";